import React from "react";
function SimpleCase() {
    return (
        <React.Fragment>
            <h5>Caso Semplice</h5>
            <p>Esempio semplice con un contatore e 2 pulsanti che aggiornano lo stato aumentando o diminuendo la variabile di 1</p>
            <iframe height="300" style={{ width: "100%" }} scrolling="no" title="useEffect - error - infinite update" src="https://codepen.io/FAngelo94/embed/gOvOeWQ?default-tab=js%2Cresult&editable=true" frameborder="no" loading="lazy" allowtransparency="true" allowfullscreen="true">
                See the Pen <a href="https://codepen.io/FAngelo94/pen/gOvOeWQ">
                    useEffect - error - infinite update</a> by Angelo Falci (<a href="https://codepen.io/FAngelo94">@FAngelo94</a>)
                on <a href="https://codepen.io">CodePen</a>.
            </iframe>
        </React.Fragment>
    );
}

export default SimpleCase;